module.exports = __webpack_public_path__ + "img/logo.143882f7.png";